/**
 * Переводы интерфейса сайта ДВ (EN, RU, DE, FR, IT)
 */
export const LANGUAGES = [
  { code: 'en', name: 'English', nameNative: 'English' },
  { code: 'ru', name: 'Russian', nameNative: 'Русский' },
  { code: 'de', name: 'German', nameNative: 'Deutsch' },
  { code: 'fr', name: 'French', nameNative: 'Français' },
  { code: 'it', name: 'Italian', nameNative: 'Italiano' },
];

const translations = {
  en: {
    drawerTitle: 'LANGUAGE',
    welcomeForm: 'HELLO! I WILL HELP YOU REGISTER.',
    agree: 'AGREE.',
    enterName: 'ENTER YOUR FIRST NAME',
    enterSurname: 'ENTER YOUR SURNAME',
    enterPhone: 'ENTER PHONE NUMBER',
    enterSmsCode: 'ENTER SMS CODE',
    enterEmail: 'ENTER EMAIL',
    enterEmailCode: 'ENTER EMAIL CODE',
    enterCarBrand: 'ENTER YOUR CAR BRAND',
    enterCarModel: 'ENTER YOUR CAR MODEL',
    enterCarColor: 'ENTER YOUR CAR COLOR',
    enterCarYear: 'ENTER CAR YEAR',
    enterLicensePlate: 'ENTER LICENSE PLATE',
    secretTitle: 'Top secret',
    zoneRL: 'ZONE RL',
    zoneRegistration: 'REGISTRATION',
    zonePersonalData: 'PERSONAL DATA',
    zoneRD: 'ZONE RD',
    zoneDocuments: 'DOCUMENTS',
    zoneRDA: 'ZONE RDA',
    zoneFleet: 'FLEET',
    selectImages: 'OK',
    passportFront: 'Take a photo of your passport front page',
    passportBack: 'PASSPORT BACK SIDE PHOTO',
    driverLicense: 'PHOTOGRAPH YOUR DRIVER\'S LICENSE',
    driverLicenseBack: 'NOW THE BACK SIDE. LIKE THIS:',
    selfie: 'TAKE YOUR PHOTO. LIKE THIS:',
    techPassport: 'PHOTOGRAPH THE TECH. PASSPORT. LIKE THIS:',
    registrationComplete: 'REGISTRATION COMPLETE',
    waitEmail: 'AWAIT EMAIL',
    thanks: 'THANK YOU',
    menuComingSoon: 'COMING SOON',
    back: 'Back',
    rights: '® DRIVERS WORLD 2025',
    allRightsReserved: 'ALL RIGHTS RESERVED',
    carBrandTitle: 'CAR BRAND',
    carModelTitle: 'CAR MODEL',
    carColorTitle: 'CAR COLOR',
    carYearTitle: 'CAR YEAR',
  },
  ru: {
    drawerTitle: 'ЯЗЫК',
    welcomeForm: 'ЗДРАВСТВУЙТЕ! Я ПОМОГУ ВАМ ЗАРЕГИСТРИРОВАТЬСЯ.',
    agree: 'СОГЛАСЕН.',
    enterName: 'ВВЕДИТЕ СВОЕ ИМЯ',
    enterSurname: 'ВВЕДИТЕ ФАМИЛИЮ',
    enterPhone: 'ВВЕДИТЕ НОМЕР ТЕЛЕФОНА',
    enterSmsCode: 'ВВЕДИТЕ SMS КОД',
    enterEmail: 'ВВЕДИТЕ ЭЛЕКТРОННУЮ ПОЧТУ',
    enterEmailCode: 'ВВЕДИТЕ КОД ИЗ EMAIL',
    enterCarBrand: 'ВВЕДИТЕ МАРКУ ВАШЕГО АВТО',
    enterCarModel: 'ВВЕДИТЕ МОДЕЛЬ ВАШЕГО АВТО',
    enterCarColor: 'ВВЕДИТЕ ЦВЕТ ВАШЕГО АВТО',
    enterCarYear: 'ВВЕДИТЕ ГОД ВЫПУСКА АВТО',
    enterLicensePlate: 'ВВЕДИТЕ ГОС. НОМЕР АВТО',
    secretTitle: 'Строго секретно',
    zoneRL: 'ЗОНА RL',
    zoneRegistration: 'РЕГИСТРАЦИИ',
    zonePersonalData: 'ЛИЧНЫХ ДАННЫХ',
    zoneRD: 'ЗОНА RD',
    zoneDocuments: 'ДОКУМЕНТЫ',
    zoneRDA: 'ЗОНА RDA',
    zoneFleet: 'АВТОПАРК',
    selectImages: 'ОКЕЙ',
    passportFront: 'Сфотографируйте лицевую страницу паспорта',
    passportBack: 'ФОТО ОБРАТНОЙ СТОРОНЫ ПАСПОРТА',
    driverLicense: 'СФОТОГРАФИРУЙТЕ ВАШЕ ВОДИТЕЛЬСКОЕ УДОСТОВЕРЕНИЕ',
    driverLicenseBack: 'ТЕПЕРЬ ОБРАТНУЮ СТОРОНУ. ВОТ ТАК:',
    selfie: 'СДЕЛАЙТЕ СВОЕ ФОТО. ВОТ ТАК:',
    techPassport: 'СФОТОГРАФИРУЙТЕ ТЕХ. ПАСПОРТ. ВОТ ТАК:',
    registrationComplete: 'РЕГИСТРАЦИЯ ЗАВЕРШЕНА',
    waitEmail: 'ОЖИДАЙТЕ ПИСЬМО НА E-MAIL',
    thanks: 'СПАСИБО',
    menuComingSoon: 'СКОРО',
    back: 'Назад',
    rights: '® DRIVERS WORLD 2025',
    allRightsReserved: 'ВСЕ ПРАВА ЗАЩИЩЕНЫ',
    carBrandTitle: 'МАРКА АВТОМОБИЛЯ',
    carModelTitle: 'МОДЕЛЬ АВТОМОБИЛЯ',
    carColorTitle: 'ЦВЕТ АВТОМОБИЛЯ',
    carYearTitle: 'ГОД ВЫПУСКА АВТОМОБИЛЯ',
  },
  de: {
    drawerTitle: 'SPRACHE',
    welcomeForm: 'HALLO! ICH HELFE IHNEN BEI DER REGISTRIERUNG.',
    agree: 'EINVERSTANDEN.',
    enterName: 'GEBEN SIE IHREM VORNAMEN EIN',
    enterSurname: 'GEBEN SIE IHREM NACHNAMEN EIN',
    enterPhone: 'GEBEN SIE DIE TELEFONNUMMER EIN',
    enterSmsCode: 'SMS-CODE EINGEBEN',
    enterEmail: 'E-MAIL EINGEBEN',
    enterEmailCode: 'E-MAIL-CODE EINGEBEN',
    enterCarBrand: 'GEBEN SIE DIE MARKE IHRES AUTOS EIN',
    enterCarModel: 'GEBEN SIE DIE MODELL IHRES AUTOS EIN',
    enterCarColor: 'GEBEN SIE DIE FARBE IHRES AUTOS EIN',
    enterCarYear: 'GEBEN SIE DAS BAUJAHR EIN',
    enterLicensePlate: 'GEBEN SIE DAS KENNZEICHEN EIN',
    secretTitle: 'Streng geheim',
    zoneRL: 'ZONE RL',
    zoneRegistration: 'REGISTRIERUNG',
    zonePersonalData: 'PERSÖNLICHE DATEN',
    zoneRD: 'ZONE RD',
    zoneDocuments: 'DOKUMENTE',
    zoneRDA: 'ZONE RDA',
    zoneFleet: 'FAHRZEUGPARK',
    selectImages: 'OK',
    passportFront: 'Fotografieren Sie die Vorderseite Ihres Passes',
    passportBack: 'FOTO DER RÜCKSEITE DES PASSES',
    driverLicense: 'FOTOGRAFIEREN SIE IHREN FÜHRERSCHEIN',
    driverLicenseBack: 'JETZT DIE RÜCKSEITE. SO:',
    selfie: 'MACHEN SIE IHR FOTO. SO:',
    techPassport: 'FOTOGRAFIEREN SIE DEN FAHRZEUGBRIEF. SO:',
    registrationComplete: 'REGISTRIERUNG ABGESCHLOSSEN',
    waitEmail: 'E-MAIL ERWARTEN',
    thanks: 'DANKE',
    menuComingSoon: 'DEMNÄCHST',
    back: 'Zurück',
    rights: '® DRIVERS WORLD 2025',
    allRightsReserved: 'ALLE RECHTE VORBEHALTEN',
    carBrandTitle: 'AUTOMARKE',
    carModelTitle: 'AUTOMODELL',
    carColorTitle: 'AUTOFARBE',
    carYearTitle: 'BAUJAHR',
  },
  fr: {
    drawerTitle: 'LANGUE',
    welcomeForm: 'BONJOUR ! JE VOUS AIDERAI À VOUS INSCRIRE.',
    agree: 'D\'ACCORD.',
    enterName: 'ENTREZ VOTRE PRÉNOM',
    enterSurname: 'ENTREZ VOTRE NOM',
    enterPhone: 'ENTREZ LE NUMÉRO DE TÉLÉPHONE',
    enterSmsCode: 'ENTREZ LE CODE SMS',
    enterEmail: 'ENTREZ L\'E-MAIL',
    enterEmailCode: 'ENTREZ LE CODE E-MAIL',
    enterCarBrand: 'ENTREZ LA MARQUE DE VOTRE VOITURE',
    enterCarModel: 'ENTREZ LE MODÈLE DE VOTRE VOITURE',
    enterCarColor: 'ENTREZ LA COULEUR DE VOTRE VOITURE',
    enterCarYear: 'ENTREZ L\'ANNÉE DU VÉHICULE',
    enterLicensePlate: 'ENTREZ LA PLAQUE D\'IMMATRICULATION',
    secretTitle: 'Strictement secret',
    zoneRL: 'ZONE RL',
    zoneRegistration: 'INSCRIPTION',
    zonePersonalData: 'DONNÉES PERSONNELLES',
    zoneRD: 'ZONE RD',
    zoneDocuments: 'DOCUMENTS',
    zoneRDA: 'ZONE RDA',
    zoneFleet: 'PARC AUTO',
    selectImages: 'OK',
    passportFront: 'Photographiez la page principale du passeport',
    passportBack: 'PHOTO DU VERSO DU PASSEPORT',
    driverLicense: 'PHOTOGRAPHIEZ VOTRE PERMIS DE CONDUIRE',
    driverLicenseBack: 'MAINTENANT LE VERSO. COMME CECI :',
    selfie: 'PRENEZ VOTRE PHOTO. COMME CECI :',
    techPassport: 'PHOTOGRAPHIEZ LA CARTE GRISE. COMME CECI :',
    registrationComplete: 'INSCRIPTION TERMINÉE',
    waitEmail: 'ATTENDEZ L\'E-MAIL',
    thanks: 'MERCI',
    menuComingSoon: 'BIENTÔT',
    back: 'Retour',
    rights: '® DRIVERS WORLD 2025',
    allRightsReserved: 'TOUS DROITS RÉSERVÉS',
    carBrandTitle: 'MARQUE DU VÉHICULE',
    carModelTitle: 'MODÈLE DU VÉHICULE',
    carColorTitle: 'COULEUR DU VÉHICULE',
    carYearTitle: 'ANNÉE DE MISE EN CIRCULATION',
  },
  it: {
    drawerTitle: 'LINGUA',
    welcomeForm: 'BUONGIORNO! TI AIUTERÒ A REGISTRARTI.',
    agree: 'ACCETTO.',
    enterName: 'INSERISCI IL TUO NOME',
    enterSurname: 'INSERISCI IL TUO COGNOME',
    enterPhone: 'INSERISCI IL NUMERO DI TELEFONO',
    enterSmsCode: 'INSERISCI IL CODICE SMS',
    enterEmail: 'INSERISCI L\'E-MAIL',
    enterEmailCode: 'INSERISCI IL CODICE E-MAIL',
    enterCarBrand: 'INSERISCI LA MARCA DELLA TUA AUTO',
    enterCarModel: 'INSERISCI IL MODELLO DELLA TUA AUTO',
    enterCarColor: 'INSERISCI IL COLORE DELLA TUA AUTO',
    enterCarYear: 'INSERISCI L\'ANNO DI IMMATRICOLAZIONE',
    enterLicensePlate: 'INSERISCI LA TARGA',
    secretTitle: 'Strettamente riservato',
    zoneRL: 'ZONA RL',
    zoneRegistration: 'REGISTRAZIONE',
    zonePersonalData: 'DATI PERSONALI',
    zoneRD: 'ZONA RD',
    zoneDocuments: 'DOCUMENTI',
    zoneRDA: 'ZONA RDA',
    zoneFleet: 'PARCO AUTO',
    selectImages: 'OK',
    passportFront: 'Scatta la foto della pagina principale del passaporto',
    passportBack: 'FOTO DEL RETRO DEL PASSAPORTO',
    driverLicense: 'FOTOGRAFA LA TUA PATENTE',
    driverLicenseBack: 'ORA IL RETRO. COSÌ:',
    selfie: 'SCATTATI UNA FOTO. COSÌ:',
    techPassport: 'FOTOGRAFA LA CARTA DI CIRCOLAZIONE. COSÌ:',
    registrationComplete: 'REGISTRAZIONE COMPLETATA',
    waitEmail: 'ATTENDI L\'E-MAIL',
    thanks: 'GRAZIE',
    menuComingSoon: 'IN ARRIVO',
    back: 'Indietro',
    rights: '® DRIVERS WORLD 2025',
    allRightsReserved: 'TUTTI I DIRITTI RISERVATI',
    carBrandTitle: 'MARCA DEL VEICOLO',
    carModelTitle: 'MODELLO DEL VEICOLO',
    carColorTitle: 'COLORE DEL VEICOLO',
    carYearTitle: 'ANNO DI IMMATRICOLAZIONE',
  },
};

export function getTranslations(locale) {
  return translations[locale] || translations.ru;
}

export default translations;
